export const scale = (size: number) => size;
export const verticalScale = (size: number) => size;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const moderateScale = (size: number, factor = 0.5) => size;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const moderateVerticalScale = (size: number, factor = 0.5) => size;

export const s = scale;
export const vs = verticalScale;
export const ms = moderateScale;
export const mvs = moderateVerticalScale;
